import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  List,
  ListItem,
  ListIcon,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaStar } from "react-icons/fa";

const KeyHighlights = ({ product }) => {
  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const headingColor = useColorModeValue("gray.800", "white");

  if (!product || !product.keyHighlights) return null;

  return (
    <Box py={16} bg={bgColor} borderRadius="xl">
      <Container maxW="6xl">
        <VStack spacing={8} align="start">
          <VStack spacing={4} align="start" w="full">
            <Heading
              as="h2"
              size="xl"
              color={headingColor}
              textAlign="center"
              w="full"
            >
              Why Choose {product.title}?
            </Heading>
            <Text
              fontSize="lg"
              color={textColor}
              textAlign="center"
              w="full"
              maxW="3xl"
              mx="auto"
            >
              Here are the key highlights that make {product.title} stand out from the competition.
            </Text>
          </VStack>

          <Box w="full">
            <List spacing={4}>
              {product.keyHighlights.map((highlight, index) => (
                <ListItem
                  key={index}
                  p={4}
                  bg="yellow.50"
                  borderRadius="lg"
                  border="1px"
                  borderColor="yellow.200"
                  _hover={{
                    bg: "yellow.100",
                    borderColor: "yellow.300",
                  }}
                  transition="all 0.3s"
                >
                  <ListIcon as={FaStar} color="yellow.500" />
                  <Text
                    display="inline"
                    fontSize="md"
                    fontWeight="medium"
                    color={headingColor}
                    lineHeight="tall"
                  >
                    {highlight}
                  </Text>
                </ListItem>
              ))}
            </List>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default KeyHighlights;
